import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 100%;
   height: 470px;
   overflow: auto;
   padding-right: 15px;

   .action,
   .toolbar,
   .statusRow,
   .warning,
   .error,
   .success,
   .sectionCard,
   .instructions-section {
      margin-bottom: 12px;
   }

   .sectionCard {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #fff;
      overflow: hidden;
   }

   .sectionToggle {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: none;
      background: #f8fafc;
      color: #111827;
      padding: 10px 12px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      text-align: left;
   }

   .sectionToggleIcon {
      font-size: 16px;
      line-height: 1;
      color: #6b7280;
      margin-left: 8px;
   }

   .sectionBody {
      padding: 10px;
      background: #fafafa;
   }

   .groupCard {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      background: #ffffff;
      padding: 10px;
   }

   .groupCard + .groupCard {
      margin-top: 10px;
   }

   .groupHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 8px;
   }

   .groupTitle {
      font-size: 13px;
      font-weight: 700;
      color: #334155;
      text-transform: capitalize;
   }

   .topicChecklist {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px 12px;
   }

   .topicItem {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      font-size: 13px;
      color: #374151;
      cursor: pointer;
      user-select: none;
      line-height: 1.35;
   }

   .topicItem input {
      width: 14px;
      height: 14px;
      accent-color: #875a7b;
      cursor: pointer;
      margin: 1px 0 0;
      flex-shrink: 0;
   }

   .topicItem.disabled {
      opacity: 0.55;
      cursor: not-allowed;
   }

   .topicMeta {
      display: flex;
      flex-direction: column;
      gap: 3px;
   }

   .topicLabel {
      font-weight: 600;
   }

   .topicHint {
      font-size: 11px;
      color: #64748b;
   }

   .toolbar {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
   }

   .primaryBtn,
   .ghostBtn {
      border: none;
      border-radius: 6px;
      padding: 8px 12px;
      font-size: 13px;
      cursor: pointer;
   }

   .primaryBtn {
      background: #875a7b;
      color: #fff;
   }

   .ghostBtn {
      background: #f1f5f9;
      color: #334155;
      border: 1px solid #dbe3ef;
   }

   .primaryBtn:disabled,
   .ghostBtn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
   }

   .statusRow {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
   }

   .statusBadge {
      border-radius: 999px;
      font-size: 11px;
      font-weight: 700;
      padding: 5px 9px;
      line-height: 1;
      letter-spacing: 0.02em;
      border: 1px solid transparent;
   }

   .statusBadge.ready {
      background: #dcfce7;
      color: #166534;
      border-color: #86efac;
   }

   .statusBadge.unknown {
      background: #fef3c7;
      color: #92400e;
      border-color: #fcd34d;
   }

   .statusBadge.missing {
      background: #fff7ed;
      color: #9a3412;
      border-color: #fdba74;
   }

   .statusBadge.loading {
      background: #f1f5f9;
      color: #475569;
      border-color: #cbd5e1;
   }

   .settingsGrid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
   }

   .field {
      display: flex;
      flex-direction: column;
      gap: 6px;
   }

   .field.full {
      grid-column: 1 / -1;
   }

   .field label {
      font-size: 12px;
      font-weight: 600;
      color: #475569;
   }

   .field input,
   .field select,
   .field textarea {
      width: 100%;
      border: 1px solid #d1d5db;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 13px;
      outline: none;
      box-sizing: border-box;
      background: #fff;
      color: #111827;
   }

   .field textarea {
      resize: vertical;
      min-height: 78px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
   }

   .field input:focus,
   .field select:focus,
   .field textarea:focus {
      border-color: #875a7b;
      box-shadow: 0 0 0 1px #875a7b;
   }

   .fieldHint {
      color: #64748b;
      font-size: 11px;
      line-height: 1.35;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 13px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .warning {
      color: #d97706;
      font-size: 13px;
   }

   .error {
      color: #dc2626;
      font-size: 13px;
   }

   .success {
      color: #166534;
      font-size: 13px;
   }

   .instructions-section h5 {
      margin: 0 0 8px;
      font-size: 14px;
      color: #111827;
   }

   .steps-list {
      margin: 0;
      padding-left: 18px;
      color: #475569;
      font-size: 13px;
      line-height: 1.5;
   }
`;
